/* template */
<template><div class="city-main"><div class="city-item city-item-cn"><div class="city-name-cn">{{ info.city_name_cn }}</div><div class="city-country-name-cn">{{ info.country_name_cn }}</div></div><div class="city-item city-item-en"><div class="city-name-en">{{ info.city_name_en }}</div><div class="city-country-name-en">{{ info.country_name_en }}</div></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m6fdc8c0c"}'>
  .city-main
    display flex
    flex-direction column
    font-size 12px
  .city-item
    display flex
    &-cn
      line-height 20px
    &-en
      margin-top 2px
      line-height 17px
  .city
    &-name-cn
      font-size 14px
      color #000000
    &-country-name-cn
      color #666666
      margin-left 8px
    &-name-en
      color #999999
    &-country-name-en
      color #bbbbbb
      margin-left 8px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6fdc8c0c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./multi-city-card.mpx.js?isComponent&outputPath=components%2Fmulti-city-card6fdc8c0c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./multi-city-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fmulti-city-card6fdc8c0c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m6fdc8c0c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/multi-city-card6fdc8c0c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
